import { generateURL } from '../../../utils/utils';

export function cardInfo(tag, card = {}) {
  return {
    game_banner: {
      data: { ...card, autoplay: true, gesture: true, type: 'fade', tag: `${tag}_Banner` },
      logInfo: { tag: `${tag}` },
    },
    three_column_rank: {
      data: { source: `${tag}` },
      logInfo: { tag: `${tag}` },
    },
    zt_list: {
      logInfo: {
        tag: `${tag}`,
      },
    },
    banner_list: {
      data: { to: generateURL(card), tag: `${tag}_ZtList`, data: card.dataList },
      logInfo: {
        tag: `${tag}`,
      },
    },
    three_parts: {
      logInfo: { tag: `${tag}` },
    },
    advert_list_three_parts: {
      logInfo: {
        tag: `${tag}`,
      },
    },
    advert_three_parts: {
      logInfo: {
        tag: `${tag}`,
      },
    },
    activity_banner: {
      logInfo: {
        tag: `${tag}`,
      },
    },
    zt_one_img: {
      logInfo: {
        tag: `${tag}`,
      },
    },
    zt_show_apps: {
      logInfo: {
        tag: `${tag}`,
      },
    },
    rank_list_four_row: {
      logInfo: {
        tag: `${tag}`,
      },
    },
    default: {
      logInfo: {
        tag: `${tag}`,
      },
    },
  };
}

export function handleCardData(data) {
  return data
    .map(card => {
      if (card.cardType === 'game_banner') {
        if (card.dataList && card.dataList.length > 0) {
          card.orderNum = -(data.length - card.orderNum);
          return card;
        }
      }

      if (card.cardType === 'three_column_rank') {
        card.dataList = (card.dataList || []).filter(group => group.apps && group.apps.length > 0);
        if (card.dataList.length > 0) {
          return card;
        }
      }

      if (card.cardType === 'zt_list') {
        if (
          card.dataList &&
          card.dataList.length > 0 &&
          card.dataList[0].ztList &&
          card.dataList[0].ztList.length >= 3
        ) {
          card.dataList[0].ztList = card.dataList[0].ztList.map(o => ({
            ...o,
            targetType: '3',
            pageCardContentId: '',
          }));
          return card;
        }
      }

      if (card.cardType === 'banner_list') {
        if (card.dataList && card.dataList.length >= 3) {
          card.dataList = card.dataList.slice(0, 10);
          return card;
        }
      }

      if (card.cardType === 'three_parts') {
        if (
          card.dataList &&
          card.dataList.length > 0 &&
          card.dataList[0].apps &&
          card.dataList[0].apps.length >= 4
        ) {
          return card;
        }
      }

      if (card.cardType === 'advert_list_three_parts') {
        if (
          card.dataList &&
          card.dataList.length > 0 &&
          card.dataList[0].advertList &&
          card.dataList[0].advertList.length >= 4
        ) {
          card.dataList[0].advertList = card.dataList[0].advertList.sort(
            (a, b) => a.orderNum - b.orderNum,
          );
          return card;
        }
      }

      if (card.cardType === 'advert_three_parts') {
        if (
          card.dataList &&
          card.dataList.length > 0 &&
          card.dataList[0].advertList &&
          card.dataList[0].advertList.length >= 4
        ) {
          card.dataList[0].advertList = card.dataList[0].advertList.sort(
            (a, b) => a.orderNum - b.orderNum,
          );
          return card;
        }
      }

      if (card.cardType === 'activity_banner') {
        if (card.dataList && card.dataList.length > 0) {
          return card;
        }
      }

      if (card.cardType === 'zt_one_img') {
        if (card.dataList && card.dataList.length > 0) {
          return card;
        }
      }

      if (card.cardType === 'zt_show_apps') {
        if (card.dataList && card.dataList.length > 0) {
          return card;
        }
      }

      if (card.cardType === 'rank_list_four_row') {
        if (
          card.dataList &&
          card.dataList.length > 0 &&
          card.dataList[0].apps &&
          card.dataList[0].apps.length >= 12
        ) {
          return card;
        }
      }

      return card;
    })
    .filter(card => !!card);
}
